import '/app/brewery-packages/content/content-editor-plugin-ordered-list/src/OrderedList.css-raw';
export default {
  "orderedList": "news-4a753f38-orderedList-Gei3fa"
};